import axios from 'axios';

// Base URL resolution
const baseURL = process.env.REACT_APP_API_URL || (typeof window !== 'undefined' ? `${window.location.origin}` : 'http://localhost:5000');

const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Attach auth token from localStorage if available
api.interceptors.request.use((config) => {
  try {
    // Attempt multiple common token keys for resilience
    const candidateKeys = ['authToken', 'token', 'jwt', 'accessToken'];
    let token;
    for (const key of candidateKeys) {
      const value = localStorage.getItem(key);
      if (value) { token = value; break; }
    }
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else if (process.env.NODE_ENV === 'development') {
      // Lightweight debug (won't spam if token present)
      // console.warn('[API] No auth token found in localStorage keys:', candidateKeys);
    }
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[API] Token retrieval error:', e);
    }
  }
  return config;
}, (error) => Promise.reject(error));

// Basic response interceptor for auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      // Optionally dispatch a logout or token refresh
      console.warn('API 401 Unauthorized');
    }
    return Promise.reject(error);
  }
);

export default api;